/**
 * @generated SignedSource<<b75cf14209b5d80ff4623c926d5c86c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type EmployeeShiftStatus = "ACTIVE" | "PAST" | "UPCOMING";
import { FragmentRefs } from "relay-runtime";
export type TVAssigneesPopover_assignableEmployee$data = {
  readonly assignableEmployees: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly shifts: ReadonlyArray<{
          readonly scheduleType: {
            readonly title: string;
          } | null;
          readonly status: EmployeeShiftStatus;
        }>;
        readonly " $fragmentSpreads": FragmentRefs<"TVAssigneesPopover_EmployeeItem">;
      };
    }>;
  };
  readonly id?: string;
  readonly " $fragmentType": "TVAssigneesPopover_assignableEmployee";
};
export type TVAssigneesPopover_assignableEmployee$key = {
  readonly " $data"?: TVAssigneesPopover_assignableEmployee$data;
  readonly " $fragmentSpreads": FragmentRefs<"TVAssigneesPopover_assignableEmployee">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "assignableEmployees"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 15,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./TVAssigneesPopoverPaginationQueryNonWorking.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "TVAssigneesPopover_assignableEmployee",
  "selections": [
    {
      "alias": "assignableEmployees",
      "args": null,
      "concreteType": "EmployeeConnection",
      "kind": "LinkedField",
      "name": "__TVAssigneesPopover_assignableEmployees_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmployeeConnectionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Employee",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "TVAssigneesPopover_EmployeeItem"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EmployeeShift",
                  "kind": "LinkedField",
                  "name": "shifts",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "EmployeeScheduleType",
                      "kind": "LinkedField",
                      "name": "scheduleType",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "title",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v1/*: any*/)
      ],
      "type": "Node",
      "abstractKey": "__isNode"
    }
  ],
  "type": "Assignable",
  "abstractKey": "__isAssignable"
};
})();

(node as any).hash = "ed38fe5d7f732c8411ea9d31ba5d7e87";

export default node;
